import { ModalActions } from './actions';
import { Modal as ModalComponent } from './modal';
import { ModalTitle } from './title';

export const Modal = Object.assign(ModalComponent, {
  Actions: ModalActions,
  Title: ModalTitle
});
